import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';

import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

export const sharedActions = getActions(
  adminPageNames.COMMUNICATIONS_MANAGEMENT,
  {
    pageTitle: adminPageTitles.COMMUNICATIONS_MANAGEMENT,
    api: getApi({
      pageTitle: adminPageTitles.COMMUNICATIONS_MANAGEMENT,
      endpoints: {
        FETCH: Config.endpoints.FETCH_ADMIN_COMMUNICATIONS,
        INSERT: Config.endpoints.ADD_COMMUNICATION,
        DELETE: Config.endpoints.REMOVE_COMMUNICATION,
        UPDATE: Config.endpoints.EDIT_COMMUNICATION,
      },
    }),
    sortingField: 'communicationId',
    agGridConfig: agGridConfig.adminCommunications,
  }
);
